import React from 'react';
import './footer.css';
function Footer ()
{
  return (
    <p className="footer">
     The Historical Society of Centinela Valley was formed in 1964. A non-profit volunteer organization, HSCV leases the Centinela Adobe Complex from the City of Inglewood and displays the society's collections of artifacts there.  
    </p>
  );
}
export default Footer;
